import { makeStyles } from '@rneui/themed'
import React from 'react'
import { ColorValue, View } from 'react-native'

interface Props {
  style?: any
  alert?: boolean
  critical?: boolean
  rightBorder?: boolean
  children?: React.ReactNode
  borderColor?: ColorValue
}

export function Card(props: Props) {
  const styles = useStyles(props)

  return (
    <View style={styles.shadow}>
      <View style={[styles.container, props.style]}>
        {!props.rightBorder && <View style={styles.alertBar} />}
        <View style={styles.inner}>{props.children}</View>
        <View style={styles.criticalBar} />
        {props.rightBorder && (
          <View
            style={[
              styles.alertBarRight,
              props.borderColor ? { backgroundColor: props.borderColor } : {},
            ]}
          />
        )}
      </View>
    </View>
  )
}

const useStyles = makeStyles((theme, props: Props) => ({
  shadow: {
    shadowColor: theme.colors?.black,
    shadowOffset: {
      width: 0,
      height: 3,
    },
    shadowRadius: 5,
    shadowOpacity: 0.18,
  },
  container: {
    flexDirection: 'row',
    borderColor: props.critical
      ? '#FFD00F'
      : props.alert
      ? theme.colors.red
      : theme.colors?.grey5,
    backgroundColor: theme.colors?.white,
    borderRadius: 15,
    borderWidth: 1,
    overflow: 'hidden',
  },
  inner: {
    paddingHorizontal: 4,
    paddingVertical: 10,
    flex: 1,
  },
  alertBar: {
    width: 8,
    backgroundColor:
      !props.critical && props.alert ? theme.colors.red : 'transparent',
    height: '100%',
    borderTopLeftRadius: 15,
    borderBottomLeftRadius: 15,
  },
  alertBarRight: {
    width: 8,
    backgroundColor:
      !props.critical && props.alert ? theme.colors.red : 'transparent',
    height: '100%',
    borderTopRightRadius: 15,
    borderBottomRightRadius: 15,
  },
  criticalBar: {
    width: 8,
    backgroundColor: props.critical ? '#FFD00F' : 'transparent',
    height: '100%',
    borderTopRightRadius: 15,
    borderBottomRightRadius: 15,
  },
}))
